import { AntdConfigProvider } from 'config/AntdConfigProvider';
import { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { dashboardRoutes } from 'routes';
import { LoadingOutlined } from '@ant-design/icons/lib/icons';
import { Auth } from 'pages/auth';
import { ReactQueryClientProvider } from 'config/ReactQueryClientProvider';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { environment } from 'config/environment';
import { RawIntlProvider } from 'react-intl';
import { intl } from 'services/intl';
import styled from '@emotion/styled';
import { FullSizeContainer } from 'components/FullSizeContainer';
import { RequireAuth } from 'components/RequireAuth';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorFallback } from 'components/ErrorFallback';

const Loader = styled(LoadingOutlined)({
  fontSize: '3rem',
});

const DashboardRouter = lazy(() => import('pages/dashboard'));

export const App = () => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <RawIntlProvider value={intl}>
        <AntdConfigProvider>
          <ReactQueryClientProvider>
            {environment.isDevelopment && <ReactQueryDevtools />}
            <BrowserRouter>
              <Routes>
                <Route
                  path={`${dashboardRoutes.root}/*`}
                  element={
                    <RequireAuth>
                      <Suspense
                        fallback={
                          <FullSizeContainer>
                            <Loader />
                          </FullSizeContainer>
                        }
                      >
                        <DashboardRouter />
                      </Suspense>
                    </RequireAuth>
                  }
                />
                <Route path="/*" element={<Auth />} />
              </Routes>
            </BrowserRouter>
          </ReactQueryClientProvider>
        </AntdConfigProvider>
      </RawIntlProvider>
    </ErrorBoundary>
  );
};
